import React from 'react'
import { Create, SimpleForm, TextInput } from 'react-admin'
import { Paper, Container } from '@mui/material'

export const ItemCreate = (props) => {
  return (
    <>
      <Container className='content'>
        <Paper className='paper_content'>
          <Create title='Create a Item' {...props}>
            <SimpleForm>
              <TextInput source='reservation' label='reservation' />
              <TextInput source='product' label='product' />
              <TextInput source='id_detail' label='id detail' />
            </SimpleForm>
          </Create>
        </Paper>
      </Container>
    </>
  )
}
